import React, {useMemo} from 'react';
import {ThemeProvider} from '@material-ui/styles';
import {useTheme} from 'styled-components';
import {createInsightsPickersTheme} from 'utils/muiPickersTheme';
import {InsightsThemeTokens} from 'utils/insightsTheme';

interface InsightsPickersThemeProviderProps {
  children: React.ReactNode;
}

export default function InsightsPickersThemeProvider({
  children,
}: InsightsPickersThemeProviderProps) {
  const theme = useTheme() as InsightsThemeTokens;
  const muiTheme = useMemo(() => createInsightsPickersTheme(theme), [theme]);

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
}
